import { BASE_URL } from ".";

const getThumbnailUrl = (url) =>
    url.includes("thumbnails") ? BASE_URL + "/" + url.substring(url.indexOf("thumbnails")) : "";

export default getThumbnailUrl;